import { render, staticRenderFns } from "./ModelAutocomplete.vue?vue&type=template&id=490f0b4a&scoped=true&"
import script from "./ModelAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ModelAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490f0b4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
